import { MobileFiltersDrawer } from "features/filters/components";

import { ACCOUNTS_FILTERS } from "../../constants";
import AccountFilterOptions from "../AccountFilterOptions";

import type { AccountSearchParams } from "../../types";

interface MobileFiltersProps {
  searchParams: AccountSearchParams;
  setSearchParams: (searchParams: AccountSearchParams) => void;
  clearSearchParams: (() => void) | undefined;
}

export default function MobileFilters({
  searchParams,
  setSearchParams,
  clearSearchParams,
}: MobileFiltersProps) {
  return (
    <MobileFiltersDrawer
      title="Filter accounts"
      onClear={(type) => {
        if (type === "all") {
          clearSearchParams();
        } else {
          setSearchParams({ ...searchParams, [type]: [] });
        }
      }}
      filters={ACCOUNTS_FILTERS}
      getSelectionCount={(filterKey) => searchParams[filterKey].length}
      renderFilter={(filterKey) => (
        <AccountFilterOptions
          searchParamsKey={filterKey}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      )}
    />
  );
}
